import { render, staticRenderFns } from "./index-Init.vue?vue&type=template&id=1ede4ba6&scoped=true"
import script from "./index-Init.vue?vue&type=script&lang=js"
export * from "./index-Init.vue?vue&type=script&lang=js"
import style0 from "./index-Init.vue?vue&type=style&index=0&id=1ede4ba6&prod&lang=less&scoped=true"
import style1 from "./index-Init.vue?vue&type=style&index=1&id=1ede4ba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede4ba6",
  null
  
)

export default component.exports